<script>
export default {
  name: 'BookingDetailsTab',
  props: {
    booking: { type: Object, default: null },
    display: { type: Function, required: true },
  },
  computed: {
    detailsComputed() {
      const b = this.booking || {}
      const grades = Array.isArray(b.grades)
        ? b.grades.map((g) => g?.title).filter(Boolean)
        : []
      return {
        grade: this.display(grades.join(', ')),
        room: this.display(b.roomNumber),
        reason: this.display(b.reason),
        bookingId: this.display(b.id != null ? `#${b.id}` : null),
        certifications:
          Array.isArray(b.certificationTypes) && b.certificationTypes.length
            ? b.certificationTypes
            : ['-'],
        internalNotes: this.display(b.clientNotes),
        educatorNotes: this.display(b.notes),
      }
    },
  },
}
</script>

<template>
  <!-- DETAILS TAB -->
  <v-tab-item>
    <div class="details-grid px-3">
      <div class="row">
        <div class="label">{{ $t('sidePanel.grade') }}</div>
        <div class="value">{{ detailsComputed.grade }}</div>
      </div>
      <div class="row">
        <div class="label">{{ $t('sidePanel.room') }}</div>
        <div class="value">{{ detailsComputed.room }}</div>
      </div>
      <div class="row">
        <div class="label">{{ $t('sidePanel.reason') }}</div>
        <div class="value">{{ detailsComputed.reason }}</div>
      </div>
      <div class="row">
        <div class="label">{{ $t('sidePanel.bookingId') }}</div>
        <div class="value">{{ detailsComputed.bookingId }}</div>
      </div>

      <div class="row">
        <div class="label">{{ $t('sidePanel.certification') }}</div>
        <div class="value">
          <span
            v-for="(c, i) in detailsComputed.certifications"
            :key="`booking-certificate-${i}`"
            :class="i % 2 === 0 ? 'pill' : 'pill-2'"
          >
            {{ c }}
          </span>
        </div>
      </div>

      <div class="row">
        <div class="label">
          {{ $t('sidePanel.internalNotes') }}
        </div>
        <div class="value">{{ detailsComputed.internalNotes }}</div>
      </div>
    </div>
  </v-tab-item>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/side-panel.scss';
</style>
